import { compact } from 'lodash'
import { useEffect } from 'react'

import { useHistoryTrackerContext } from '../providers/HistoryTrackerProvider'

export const usePageTitle = (title: string | undefined) => {
    const { overrideLastEntryPageTitle } = useHistoryTrackerContext()

    useEffect(() => {
        document.title = compact([title, 'PocketSuite']).join(' | ')
        overrideLastEntryPageTitle(title)
    }, [title])
}
